import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';

@Component({
  selector: 'app-download-popup',
  templateUrl: './download-popup.component.html',
  styleUrls: ['./download-popup.component.scss'],
})
export class DownloadPopupComponent {
  tableData: any;
  selectedRows: Set<string> = new Set(); // store legids of checked rows
  changedRows: Set<string> = new Set();
  selectedReportType: string = 'csv';
  isReportType: boolean = false;
  istable: boolean = false;
  formData = {
    imo: '',
    from_date: '',
    to_date: '',
    vessel_name: '',
    client: '',
    mgo: '',
    meraki_pic: '',
    type_periodic: '',
  };
  clients = ['Eiger', 'ZeroNorth', 'Elite'];
  merakiPics = [
    { label: 'AAY - Aayush Singh Parmar', value: 'AAY' },
    { label: 'AMA - Amrit Anand', value: 'AMA' },
    { label: 'ANKU - Usha Kumari', value: 'ANKU' },
    { label: 'AJK - Ajeet Kumar', value: 'AJK' },
    { label: 'DEB - Deepika Bhardwaj', value: 'DEB' },
    { label: 'GMK - Gaurav Mohan Kulkarni', value: 'GMK' },
    { label: 'GUS - Gurvinder Singh', value: 'GUS' },
    { label: 'HAS - Harshi Jain', value: 'HAS' },
    { label: 'KER - Keerthana Rajamani', value: 'KER' },
    { label: 'KPJ - Kinshuk Pragya Jha', value: 'KPJ' },
    { label: 'MAL - Malini Sivaranjini', value: 'MAL' },
    { label: 'MNG - Manisha Ganesh', value: 'MNG' },
    { label: 'NAB - Nancy Baidya', value: 'NAB' },
    { label: 'PHJ - Philomina Johnthomas', value: 'PHJ' },
    { label: 'STP - Shatakshi Priya', value: 'STP' },
    { label: 'SNK - Sonu Kumar', value: 'SNK' },
    { label: 'SOS - Souta Samanta', value: 'SOS' },
    { label: 'SUTH - Suman Saurav Thakur', value: 'SUTH' },
  ];

  typePeriodicOptions = ['Voyage extrapolation', 'Period extrapolation', 'Cumulative'];
  formId: any;
  constructor(
    public dialogRef: MatDialogRef<DownloadPopupComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dashboardService: DashboardService,
    private overlayService: OverlapService
  ) {}
  ngOnInit() {
    // Set initial smaller size when popup opens
    this.dialogRef.updateSize('500px', '40vh');
    if (this.data) {
      this.formData.vessel_name = this.data.vessel_name || '';
      this.formData.imo = this.data.imo || '';
      this.formData.client = this.data.client || '';
      this.formData.from_date = this.data.from_date || '';
      this.formData.to_date = this.data.to_date || '';
      // Optionally, you can set default values for MGO, PIC, Type Periodic if needed
      this.formData.mgo = this.data.mgo || '';
      this.formData.meraki_pic = this.data.meraki_pic || '';
      this.formData.type_periodic = this.data.type_periodic || '';
    }
  }
  onSubmit(isSubmit: boolean) {
    if (isSubmit) {
      if (this.selectedReportType === 'csv') {
        this.dialogRef.close(this.selectedReportType);
      } else {
        // this.toastr.error(ToasterMessages.UnderDev);
        this.isReportType = true;
        this.dialogRef.updateSize('800px', '80vh');
      }
    } else {
      this.dialogRef.close();
    }
  }

  submitReport() {
    const from_date_val = this.formData.from_date;
    const to_date_val = this.formData.to_date;
    function formatDate(dateInput: any): string {
      const d = new Date(dateInput);
      const pad = (num: number) => num.toString().padStart(2, '0');

      const year = d.getFullYear();
      const month = pad(d.getMonth() + 1);
      const day = pad(d.getDate());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    const from_date_str = formatDate(from_date_val);
    const to_date_str = formatDate(to_date_val);
    let payload = {
      imo: this.formData.imo,
      from_date: from_date_str,
      to_date: to_date_str,
      vessel_name: this.formData.vessel_name,
      client: this.formData.client,
      mgo: this.formData.mgo,
      meraki_pic: this.formData.meraki_pic,
      type_periodic: this.formData.type_periodic,
    };

    this.dashboardService.getPeriodicSummary(payload).subscribe(
      (data) => {
        this.dialogRef.updateSize('1230px', '80vh');
        this.istable = true;
        this.formId = Object.keys(data)[0];
        console.log('Form ID:', this.formId);
        const firstKey = Object.keys(data)[0];
        this.tableData = (data as any)[firstKey].map((leg: any) => ({
          ...leg,
          gw_fuel_type_used: leg.gw_fuel_type_used || '',
          overall_fuel_type_used: leg.overall_fuel_type_used || '',
          warranted_leg: leg.warranted_leg || '',
          rowChanged: false,
          checked: false,
        }));
      },
      (error) => {
        this.toastr.error(error.statusText);
      }
    );
  }

  onRowChange(leg: any) {
    leg.rowChanged = true;
    this.changedRows.add(leg.legid);
  }

  toggleRowSelection(leg: any, event: any) {
    leg.checked = event.target.checked;
    if (leg.checked) {
      this.selectedRows.add(leg.legid);
    } else {
      this.selectedRows.delete(leg.legid);
    }
  }

  updateRow(leg: any) {
    const payload = {
      leg_id: leg.legid,
      gw_fuel_type: leg.gw_fuel_type_used,
      ove_fuel_type: leg.overall_fuel_type_used,
      warranted_leg_status: leg.warranted_leg,
      cp_ord_con_go:leg.cp_ord_con_go,
      mgo: this.formData.mgo || '',
    };
    console.log(payload);
    this.dashboardService.updatePeriodicSummaryRow(payload).subscribe(
      (data) => {
        leg.rowChanged = false;
        this.changedRows.delete(leg.legid);
        this.toastr.success(ToasterMessages.Update);
      },
      (error) => {
        this.toastr.error(error.statusText);
      }
    );
  }

  submitClick() {
    const selectedLegs = this.tableData.filter((leg: any) => leg.checked);

    if (selectedLegs.length === 0) {
      console.warn('No rows selected!');
      return;
    }
    const legIds = selectedLegs.map((leg: any) => leg.legid);

    const payload = {
      leg_ids: legIds.join(','),
      form_id: this.formId,
      client_name: this.formData.client,
      type_periodic: this.formData.type_periodic,
      vessel_name: this.formData.vessel_name
    };

    this.dashboardService.generatePeriodicSummaryPdf(payload).subscribe(
      (data) => {
        this.overlayService.showPdf(data);

        this.dialogRef.close();
      },
      (error) => {
        this.toastr.error(error.statusText);
      }
    );
  }
}
